const GOOGLE_IDENTITY_SCRIPT = "https://accounts.google.com/gsi/client";

let scriptPromise;

export function loadGoogleIdentity() {
  if (window.google?.accounts?.id) return Promise.resolve(window.google.accounts.id);
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.async = true;
      script.src = GOOGLE_IDENTITY_SCRIPT;
      script.onload = () => {
        if (window.google?.accounts?.id) resolve(window.google.accounts.id);
        else reject(new Error("Google sign-in is unavailable."));
      };
      script.onerror = () => reject(new Error("Google sign-in could not load."));
      document.head.appendChild(script);
    }).catch((error) => {
      scriptPromise = undefined;
      throw error;
    });
  }
  return scriptPromise;
}

export async function googleNonceDigest(nonce) {
  const bytes = new TextEncoder().encode(nonce);
  const digest = await window.crypto.subtle.digest("SHA-256", bytes);
  return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, "0")).join("");
}
